import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortName',
  standalone: false,
  pure: false,
})
export class ShortNamePipe implements PipeTransform {
  transform(value?: string | null): string {
    return formatShortName(value);
  }
}

export function formatShortName(fullName?: string | null): string {
  if (!fullName?.trim()) {
    return '';
  }

  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0];
  }

  const firstInitial = parts[0].charAt(0).toUpperCase();
  const lastName = parts.at(-1);

  return `${firstInitial}. ${lastName}`;
}
